  <template>
  <!-- <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"> -->
  <!-- {{editedData} -->

  <!-- <div class="mt-6 flex items-center justify-between px-6">
      <h4>Edit Dynamic Fields for {{label}}</h4>
      <feather-icon icon="XIcon" class="cursor-pointer" @click.stop="isSidebarActiveLocal = false"/>
    </div>
    <vs-divider class="mb-0" /> -->
  <div class="py-0 p-2">
    <div class="vx-row">
      <div class="vx-col w-full">
        <form data-vv-scope="addCustomField">
          <div class="p-1">
            <label class="vs-input--label">Field Name</label>
            <vs-input
              class="w-full"
              onkeypress="return (event.charCode !=47)"
              v-validate="'required|min:3'"
              name="attributeName"
              v-model="editedItem.name"
              data-vv-validate-on="blur"
              @mouseleave="checkAttribute"
            />

            <div
              v-if="errors.has('addCustomField.attributeName')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("addCustomField.attributeName") }}
            </div>
            <div
                v-if="showError"
                style="color:red;"
                class="invalid-feedback"
              >This field is already existing as a static field</div>
          </div>

          <!-- {{items}} -->
          <!-- {{selected_items}} -->
          <!-- {{ filteredArray }} -->
          <div class="p-1">
            <label class="vs-input--label">Input Field types</label>
            <v-select
              placeholder="select field type"
              v-model="selected_items"
              :clearable="false"
              :options="filteredArray"
              v-validate="'required'"
              name="inputfieldtype"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <!-- {{filteredArray}} -->
            <div
              v-if="errors.has('addCustomField.inputfieldtype')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("addCustomField.inputfieldtype") }}
            </div>
          </div>
          <!-- {{editedItem}} -->

          <!-- {{editedData}} -->

          <div
            class="p-1"
            v-if="
              editedData.inputtype == 'select' ||
              editedData.inputtype == 'checkbox' ||
              editedData.inputtype == 'radio'
            "
          >
            <small
              style="color: #0382c9"
              v-if="
                editedData.inputtype == 'select' ||
                editedData.inputtype == 'checkbox' ||
                editedData.inputtype == 'radio' ||
                editedData.inputtype == 'multiselect'
              "
              >Notes : Distinct values should be on its own line</small
            >
            <br />
            <label
              v-if="
                editedData.inputtype == 'select' ||
                editedData.inputtype == 'checkbox' ||
                editedData.inputtype == 'radio'
              "
              class="vs-input--label"
              >Values</label
            >
            <vs-textarea
              v-model="optionvalue"
              v-if="
                editedData.inputtype == 'select' ||
                editedData.inputtype == 'checkbox' ||
                editedData.inputtype == 'radio' ||
                editedData.inputtype == 'multiselect'
              "
            />
          </div>
          <!-- {{items}} -->

          <!-- {{items}}
            {{editedItem}} -->
          <!-- {{editedData}} -->
          <!-- <ul v-if="editedData.multivalue.length">

              <li v-for="multivalue in editedData.multivalue " :key="multivalue.id">
              {{multivalue.optionsvaluename}}</li>
            </ul> -->
          <transition name="fade" mode="out-in">
            <vs-alert
              v-if="optiondeletealert"
              color="danger"
              title="Danger"
              active="true"
            >
              {{ optiondeletemessage }}
            </vs-alert>
          </transition>
          <vs-list v-if="editedData.multivalue.length">
            <span style="float: right; margin: 10px"> <b>Delete</b></span>
            <vs-list-header title="Options Value"></vs-list-header>
            <vs-list-item
              v-for="multivalue in editedData.multivalue"
              :key="multivalue.id"
              :title="multivalue.optionsvaluename"
            >
              <vs-checkbox
                v-model="checkboxremovearr"
                :vs-value="multivalue.id"
                color="primary"
              ></vs-checkbox>
              <!-- <vs-button color="danger" @click="DeleteOption(multivalue.id)">X</vs-button> -->
            </vs-list-item>
            <!-- {{checkboxremovearr}} -->
          </vs-list>
          <div class="p-1">
            <vs-textarea
              v-model="editedItem.description"
              label="Description"
              placeholder="Please write small description for the attribute"
              height="110px"
            />
          </div>

          <vs-col vs-type="flex" vs-justify="left" vs-align="left">
            <vs-checkbox v-model="editedItem.is_required"
              >Is Required</vs-checkbox
            >
          </vs-col>
        </form>
      </div>
    </div>

    <!-- {{editedItem}} -->

    <div class="vx-row mt-5">
      <div class="vx-col flex">
        <vs-button
          :disabled="showError"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click.prevent="update_dynamicfields()"
          >Update</vs-button
        >
      </div>
    </div>
  </div>
  <!-- {{editedData}} -->
  <!-- </vs-sidebar> -->
</template>
          
<script>
import { updateCustomField, DeleteMultiOption, fetchCustomStaticFields } from '@/api/customfield'
import vSelect from 'vue-select'

export default {
  name: 'EditSidebarDynamic',
  components: {
    vSelect
  },
  props: {
    label: {
      type: String,
      required: true
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    entityModel: {
      type: String,
      required: true
    },
    editedData: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.filterTextData()
    this.selectedfilter()
    // 
  },
  data () {
    return {
      optionvalue: '',
      selected_items: {},
      editedItem: {
        name: this.editedData.label,
        is_required: this.editedData.is_required,
        inputtype: this.selected_items,
        // multioptionvalue:this.editedData.multivalue,
        description: this.editedData.description
      },

      addSideBar: false,
      custom_fields: [],
      attribute_name: '',
      attribute_type: '',
      isrequired: false,
      input_field_type: '',
      // optionvalue:'',
      multioptionvalue: [],
      filteredArray: [],

      checkboxremovearr: [],

      inputfieldtype: [
        { label: 'Text', value: 'text', datatype: 'varchar', similar: 'text' },
        {
          label: 'Text Area',
          value: 'textarea',
          datatype: 'text',
          similar: 'text'
        },
        {
          label: 'Radio Button',
          value: 'radio',
          datatype: 'varchar',
          similar: 'singleselect'
        },
        {
          label: 'Dropdown',
          value: 'select',
          datatype: 'varchar',
          similar: 'singleselect'
        },
        {
          label: 'Number',
          value: 'number',
          datatype: 'integer',
          similar: 'number'
        },
        {
          label: 'Date',
          value: 'datetime',
          datatype: 'datetime',
          similar: 'datetime'
        },
        {
          label: 'Boolean',
          value: 'boolean',
          datatype: 'boolean',
          similar: 'boolean'
        },
        {
          label: 'Checkbox',
          value: 'checkbox',
          datatype: 'varchar',
          similar: 'multiselect'
        },
        {
          label: 'Multi Select',
          value: 'multiselect',
          datatype: 'varchar',
          similar: 'multiselect'
        }
      ],
      optiondeletealert: false,
      optiondeletemessage: '',
      staticFields: [],
      module_id: '',
      modulename: this.$route.params.modelname,
      showError: false
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.initdefault()
          this.$emit('closeSidebarEditEvent', false)
        }
      }
    },

    lineCount () {
      // Return number of lines using regex if not empty
      return this.optionvalue.length
        ? this.optionvalue.split(/\r\n|\r|\n/).length
        : 0
    },
    items () {
      const items = this.optionvalue.split('\n')
      return this.optionvalue !== '' && !!this.optionvalue.length ? items : []
    }
  },
  created () {
    this.fetch_module_static_column_list()
  },
  watch: {
    editedData:{
      deep:true,
      immediate:true,
      handler () {
        this.editedItem.name  = this.editedData.label
        this.editedItem.is_required  = this.editedData.is_required
        this.editedItem.inputtype = this.selected_items
        this.editedItem.description = this.editedData.description
      }
    },
    selected_items () {
      this.editedItem.inputtype = this.selected_items
    }
  },
  methods: {
    checkAttribute () {
      const res = this.staticFields.filter((item) => {
        // eslint-disable-next-line eqeqeq
        return item.field_label == this.editedItem.name
      })
      if (res.length !== 0) {
        this.showError = true
      } else {
        this.showError = false
      }
    },
    async fetch_module_static_column_list () {
      this.$vs.loading({text:'Fetching Dynamic Field'})
      try {
        
        if (this.modulename == 'Leads') {
          this.module_id = 1
        } else if (this.modulename == 'Client') {
          this.module_id = 4
        } else if (this.modulename == 'Staff') {
          this.module_id = 38
        }

        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(this.module_id, customerId)
        this.staticFields = data.data.module_fields
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    selectedfilter () {
      const data = this.editedData.inputtype

      
      this.selected_items = this.filteredArray.find(
        (ele) => ele.value === data
      )
    },
    filterTextData () {
      let similarText = ''
      
      if (
        this.editedData.inputtype === 'text' ||
        this.editedData.inputtype === 'textarea'
      ) {
        similarText = 'text'
      } else if (
        this.editedData.inputtype === 'radio' ||
        this.editedData.inputtype === 'select'
      ) {
        similarText = 'singleselect'
      } else if (
        this.editedData.inputtype === 'checkbox' ||
        this.editedData.inputtype === 'multiselect'
      ) {
        similarText = 'multiselect'
      } else {
        similarText = this.editedData.inputtype
      }
      
      const arrayFiltered = this.inputfieldtype.filter((element) => {
        return element.similar === similarText
      })

      this.filteredArray = arrayFiltered
      
      //   
    },
    update_dynamicfields () {
      this.editedItem.inputtype = this.selected_items.value
      
      const payload = {
        update_field: this.editedItem,
        attribute_id: this.editedData.attribute_id
      }
      
      this.$validator.validateAll('addCustomField').then((valid) => {
        if (valid) {
          const data = payload
          // const data = {
          // // attribute_type:this.attribute_type.value,
          //   attribute_type:this.input_field_type.datatype,
          //   attribute_name:this.attribute_name,
          //   is_required:this.isrequired,
          //   entity:this.entityModel,
          //   inputtype:this.selected_items,
          //   is_collection: false
          // }
          // 
          // 

          //this function is to remove empty line from array
          if (this.items.length > 0) {
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i] === '') {
                this.items.splice(i, 1)
              }
            }
          }

          if (
            this.input_field_type.value === 'text' ||
            this.input_field_type.value === 'textarea' ||
            this.input_field_type.value === 'number' ||
            this.input_field_type.value === 'datetime' ||
            this.input_field_type.value === 'boolean'
          ) {
            //it is to remove items value if the value is text
            this.items.length = 0
          }

          if (
            this.checkboxremovearr.length ===
              this.editedData.multivalue.length &&
            this.editedData.multivalue.length > 0
          ) {
            
            if (this.items.length < 1) {
              this.$vs.notify({
                title: 'Warning',
                text: 'Atleast One field required for option value',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
              return false
            }
          }

          // else if (this.items.length < 1) {

          //   this.$vs.notify({
          //     title: 'Warning',
          //     text: 'Atleast One field required for option value',
          //     iconPack: 'feather',
          //     icon: 'icon-alert-circle',
          //     color: 'warning',
          //     position:'top-center'

          //   })
          //   return false
          // }

          // if (this.input_field_type.value === 'checkbox'  || this.input_field_type.value === 'multiselect') {
          //   data['is_collection'] = true
          // }

          // data.multivalue = this.items
          //now assignig items into

          data.multivalue = this.items
          data.deletemultivalue = this.checkboxremovearr

          

          this.UpdateFields(data)
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Validation Field Required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })
    },
    async UpdateFields (data) {
      
      
      const payload = data

      

      try {
        const { data } = await updateCustomField(payload)
        const editedDataObj = data.data.attributes
        
        this.$vs.notify({
          title: 'Success',
          text: 'Dynamic field updated successfully.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.$validator.reset()

        // data['attribute'].attribute_id = data.id

        // data.data.attribute.label = data.data.attribute.name

        // data.data.attribute.save = false
        // data.data.attribute.disable = true

        // this.custom_fields.push(data.data.attribute)
        // 
        this.initdefaultvalues(editedDataObj)
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Something Went Wrong PLeas Try Again',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        // this.initdefaultvalues()
        
      } finally {
        
      }
    },
    DeleteOption (id) {
      
      
      if (this.editedData.multivalue.length === 1) {
        this.optiondeletealert = true
        this.optiondeletemessage =
          'There should be atleast one option you cant delete it'

        // setTimeout(() => this.optiondeletealert = false, 3000)
      } else {
        this.deleteoption(id)
      }
    },
    async deleteoption (id) {
      try {
        const data = await DeleteMultiOption(id)
        const index = this.editedData.multivalue.findIndex(
          (element) => element.id === id
        )
        const nameoption = this.editedData.multivalue[index].optionsvaluename
        this.optiondeletemessage = `${nameoption} options deleted successfully`
        
        this.editedData.multivalue.splice(index, 1)
        this.optiondeletealert = true
        // setTimeout(() => this.optiondeletealert = false, 2000)

        
      } catch (e) {
        
      }
    },
    // delete_option
    initdefault () {
      this.attribute_name = ''
      this.attribute_type = ''
      this.items.length = 0
      this.optionvalue = ''
      this.input_field_type = ''
      this.isrequired = false
    },
    initdefaultvalues (obj) {
      this.$emit('closeSidebarEditEvent', obj)
    }
  }
}
</script>
<style scoped>
/* .vs-sidebar .vs-sidebar--items{
    overflow-y: scroll !important;
  } */

.vs-sidebar .vs-sidebar--items {
  overflow: auto;
}

.add-new-data-sidebar ::v-deep .vs-sidebar--background {
  z-index: 52010;
}
.add-new-data-sidebar ::v-deep .vs-sidebar {
  z-index: 52010;
  width: 400px;
  max-width: 90vw;
}
</style>
